import { Context, createContext } from 'react';
import { Theme } from '@gs-ux-uitoolkit-common/theme';
import { lightTheme } from '@gs-ux-uitoolkit-common/theme';

export const ThemeContext: Context<Theme> = createContext(lightTheme);
